import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.0354 3.01443C17.16 1.88971 18.9556 1.84472 20.134 2.87946L20.278 3.01443L20.9851 3.72153C22.1098 4.84624 22.1548 6.6418 21.1201 7.82018L20.9851 7.96417L9.77281 19.1765C9.61378 19.3355 9.42155 19.4562 9.21077 19.5305L9.04943 19.5774L4.59453 20.6055C3.91174 20.763 3.29593 20.1916 3.37445 19.5181L3.39408 19.4051L4.42213 14.9501C4.4727 14.7309 4.57173 14.5267 4.71109 14.352L4.82306 14.2268L16.0354 3.01443ZM15.3282 6.55002L6.33867 15.5396L5.70227 18.2973L8.45999 17.6609L17.4495 8.67134L15.3282 6.55002ZM18.8638 4.42864C18.5033 4.06816 17.9361 4.04043 17.5438 4.34545L17.4496 4.42864L16.7424 5.13581L18.8637 7.25713L19.5709 6.54996C19.9314 6.18948 19.9591 5.62224 19.6541 5.22995L19.5709 5.13575L18.8638 4.42864Z" })
});
export default SvgPencilLine;
